import networkService from "./networkService";

class UserService {

    async getUser() {
        const result = await networkService.get<any>("/user");
        if (result.isSuccessful) {
            return result.data;
        }

        throw result.data;
    }
}

const userService = new UserService();
export default userService;